module.exports = __webpack_public_path__ + "media/images/landing_section_1-2de81bc08f268891a3fbb18714c3d6d7.svg";